import React from "react";
import "./ProcessExpect.scss";

const processItems = [
  {
    title: "User-centered Approach",
    description:
      "We prioritize users, conducting thorough research to create designs that resonate, enhancing engagement and fostering lasting connections.",
  },
  {
    title: "Data-Informed Decisions",
    description:
      "We leverage user behavior insights, aligning design choices with data for optimal usability and impactful user interactions.",
  },
  {
    title: "Holistic Strategy",
    description:
      "We unify UX, UI, and functionality seamlessly, crafting designs that authentically reflect your brand, delivering holistic and cohesive experiences.",
  },
  {
    title: "Tailored Solutions",
    description:
      "We delve into user personas, forging custom solutions to address specific challenges, ensuring designs align precisely with user need.",
  },
  {
    title: "Timely Delivery",
    description:
      "Our streamlined workflows and strategic planning ensure projects are delivered promptly, adhering to your timelines without compromise.",
  },
  {
    title: "Long Term Viability",
    description:
      "With in-depth foresight, we design for longevity, anticipating trends and changes, which results in sustained relevance and minimized need for constant updates.",
  },
];

const ProcessExpect = () => {
  return (
    <section className="section processExpect">
      <article className="processExpect__container container">
        <div className="processExpect__container--title">
          <h3 className="processExpect__title">WHAT TO EXPECT</h3>
        </div>
        <div className="processExpect__container--contents">
          {processItems.map((item, index) => (
            <div
              className="processExpect__container--contents-items"
              key={index}
            >
              <h3 className="contents-items-title">{item.title}</h3>
              <p className="contents-items-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </article>
    </section>
  );
};

export default ProcessExpect;
